import React from 'react';
import {VerifierView} from './container';

export const VerifierScreen = () => {
  return <VerifierView />;
};